// extracted by mini-css-extract-plugin
export var createdDate = "_n2-1";
export var divider = "_n2-2";
export var headerDivider = "_n2-3";
export var messagesCard = "_n2-0";
export var messagesContainer = "_n2-6";
export var messagesContainerWrapper = "_n2-4";
export var showLeftPanelButton = "_n2-8";
export var topButtons = "_n2-7";
export var withPadding = "_n2-5";